import {connect} from 'react-redux';

import {getUser} from 'mattermost-redux/selectors/entities/users';

import {type Post} from 'mattermost-redux/types/posts';

import {type GlobalState} from 'types/store';

import {getDisplayNameByUser} from 'utils/utils';

import {getPostOverrideUsername} from 'features/posts/selectors/get_post_override_username';

import CommentedOn from './commented_on';

type Props = {
    post: Post;
}

function mapStateToProps(state: GlobalState, ownProps: Props) {
    let displayName = '';
    if (ownProps.post) {
        const user = getUser(state, ownProps.post.user_id);
        displayName = getDisplayNameByUser(state, user);
    }

    return {
        displayName,
        overrideUsername: getPostOverrideUsername(state, ownProps.post),
    };
}

export default connect(mapStateToProps)(CommentedOn);
